import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../home/header";
import Footer from "../home/footer";

const Myorder = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔐 AUTH CHECK
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.email) {
      navigate("/login");
    }
  }, [navigate]);

  // 📦 FETCH ORDERS BY EMAIL (LATEST FIRST)
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.email) return;

    fetch(`https://ankit1.jaskart.com/orders/email/${user.email}`)
      .then((res) => res.json())
      .then((data) => {
        const sortedOrders = (data.orders || []).sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        setOrders(sortedOrders);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // ✅ SHOW ONLY COMPLETED + PAID ORDERS
  const completedOrders = orders.filter(
    (order) =>
      order.status === "COMPLETED" &&
      order.paymentStatus === "COMPLETED"
  );

  return (
    <>
      <Header />

      <div className="container mt-5 mb-5">
        <h2 className="mb-4">My Orders</h2>

        {loading ? (
          <p>Loading...</p>
        ) : completedOrders.length === 0 ? (
          <p>No completed orders found</p>
        ) : (
          completedOrders.map((order, orderIndex) => {
            // 🔁 Normalize items (single OR multiple)
            const items = order.items
              ? order.items
              : order.product
              ? [order.product]
              : [];

            return (
              <div
                key={order.orderId}
                className="card mb-4 p-4"
                style={{ boxShadow: "5px 5px #ccc" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">
                    Order ID: {order.orderId}
                    {orderIndex === 0 && (
                      <span className="badge bg-primary ms-2">
                        Latest
                      </span>
                    )}
                  </h6>
                </div>

                <small className="text-muted">
                  Ordered on:{" "}
                  {new Date(order.createdAt).toLocaleString()}
                </small>

                <hr />

                {/* 🧾 ORDER ITEMS */}
                {items.map((item, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between"
                  >
                    <p className="mb-1">
                      {item.name} × {item.quantity}
                    </p>
                    <p className="mb-1">
                      ₹{item.price * item.quantity}
                    </p>
                  </div>
                ))}

                <hr />

                <div className="text-end">
                  <p className="mb-1">Delivery: FREE</p>
                  <h5>Total: ₹{order.amount}</h5>
                </div>
              </div>
            );
          })
        )}
      </div>

      <Footer />
    </>
  );
};

export default Myorder;
